const NODE_GROUPING_PREFIX = 'node_group';
export const NODE_GROUPING_EVENT_NAMES = {
  CREATED: `${NODE_GROUPING_PREFIX}_created`,
  DELETED: `${NODE_GROUPING_PREFIX}_deleted`,
  UNGROUPED: `${NODE_GROUPING_PREFIX}_ungrouped`,
  ATTACHED: `${NODE_GROUPING_PREFIX}_attached`,
  DETACHED: `${NODE_GROUPING_PREFIX}_detached`,
  COLOR_CHANGED: `${NODE_GROUPING_PREFIX}_color_changed`,
  RENAMED: `${NODE_GROUPING_PREFIX}_renamed`,
  LABEL_SIZE_CHANGED: `${NODE_GROUPING_PREFIX}_label_size_changed`,
};

const PROMPT_VARIABLE_PREFIX = 'prompt_variables';
export const PROMPT_VARIABLE_EVENT_NAMES = {
  ADD_VARIABLE: `${PROMPT_VARIABLE_PREFIX}_add_variable`,
  CREATE_VARIABLE: `${PROMPT_VARIABLE_PREFIX}_create_variable`,
};

export const PACK_UNPACK_EVENT_NAMES = {
  UNPACK_NODE: `Click unpack node`,
  CREATE_ITERATOR_FROM_NODE: `Click create iterator from node`,
  CREATE_ITERATOR_FROM_GROUP: `Click create iterator from group`,
};

const CANCEL_PLAN_PREFIX = 'cancel_plan';
export const CANCEL_PLAN_EVENT_NAMES = {
  DIALOG_OPENED: `${CANCEL_PLAN_PREFIX}_dialog_opened`,
  CONFIRMED: `${CANCEL_PLAN_PREFIX}_confirmed`,
  KEPT_PLAN: `${CANCEL_PLAN_PREFIX}_kept_plan`,
};
